import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { WintSuperkollAPIModel, WintSuperkollAPIModelAccounting } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
//#endregion
import { useAccountService } from "serviceHooks";
import { useLocation, useNavigate } from "react-router-dom";
import { FormFieldConstants } from "utils/constants";
import { QueryStateHelper, UrlHelper } from "utils/helpers";

const CostReportDoughnutChart: React.FC = () => {
  const accountService = useAccountService();
  const navigate = useNavigate();
  const location = useLocation();

  const accountNumberEncoder = QueryStateHelper.multipleAutoCompleteItemsQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.AccountNumbers
  );

  const bookingDateEncoder = QueryStateHelper.dateRangeQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.BookingDate
  );

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.DashboardCostsAccountSummeryPieWidget}
      chartCacheKey={GraphConstants.ChartKeys.DashboardCostsAccountSummeryPieWidget}
      doughnutChartLegendType={ChartEnums.LegendType.LARGE}
      doughnutChartColorPalette={ChartEnums.DoughnutChartColorPalette.DEFAULT}
      useClickableChart
      onDataPointClick={async (_index, label) => {
        const clickedLabel = typeof label === "string" ? label : Array.isArray(label) ? String(label[0]) : undefined;
        if (!clickedLabel) return;

        const accountsRes = await accountService.getAccounts({
          name: clickedLabel,
          active: true,
        } as WintSuperkollAPIModelAccounting.AccountFilter);

        const accountItem = accountsRes?.items && accountsRes.items[0];

        if (!accountItem?.id || !accountItem?.number) return;

        const today = new Date();
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(today.getFullYear() - 1);

        const params = new URLSearchParams("");
        accountNumberEncoder.urlEncode(params, undefined, [{ id: accountItem.id, value: String(accountItem.number) }]);
        bookingDateEncoder.urlEncode(params, undefined, { start: oneYearAgo, end: today });

        navigate(`${UrlHelper.formatPath(`/Reports/Accounting`)}?${params.toString()}`, {
          state: { background: location },
        });
      }}
    />
  );
};

export default CostReportDoughnutChart;
